import { TCustomerFullInfoVisibleForm } from '../../CustomerFullInfo/customerFullInfoState/customerFullInfoContext';
import { createContext } from 'react';
import { TCountOfItems, ICustomers, TTypeOfServiceProvided, EntityStatus } from 'types';

export type TCustomersSortBy = '' | 'NameA-Z' | 'NameZ-A' | 'Rest/Hotel1-10' | 'Rest/Hotel10-1';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmDeleteItem'
	| 'toConfirmArchiveItem'
	| 'toConfirmRestoreItem'
	| 'success'
	| 'error'
	| 'archiveSuccess'
	| 'archiveError'
	| 'restoreSuccess'
	| 'restoreError';
export interface IFullInfoData {
	id: string;
	activeTab?: TCustomerFullInfoVisibleForm;
}
export interface IFilterValues {
	searchString: string;
	selectedClientType: Nullable<TTypeOfServiceProvided>;
	status: EntityStatus;
	sortBy: TCustomersSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
}

export interface ICustomersState {
	customers: ICustomers;
	searchString: string;
	selectedClientType: Nullable<TTypeOfServiceProvided>;
	status: EntityStatus;
	sortBy: TCustomersSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	IDForArchiving: string;
	IDForRestoring: string;
	fullInfoData: IFullInfoData;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const customersInitialState: ICustomersState = {
	customers: { customers: [], customerCount: 0 },
	searchString: '',
	selectedClientType: null,
	status: EntityStatus.Active,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	IDForArchiving: '',
	IDForRestoring: '',
	fullInfoData: {
		id: '',
	},
	typeOfModalWindow: null,
};

export interface ICustomersContext extends ICustomersState {
	deleteSelectedItem(): void;
	archiveSelectedItem(): void;
	restoreSelectedItem(): void;
	changeSearchString(value: string): void;
	setClientType(value: Nullable<TTypeOfServiceProvided>): void;
	setStatus(value: EntityStatus): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TCustomersSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForArchiving(value: string): void;
	setIDForRestoring(value: string): void;
	setFullInfoData(value: string, activeTab?: TCustomerFullInfoVisibleForm): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const CustomersContext = createContext<ICustomersContext>({
	deleteSelectedItem: async () => undefined,
	archiveSelectedItem: async () => undefined,
	restoreSelectedItem: async () => undefined,
	changeSearchString: () => undefined,
	setClientType: () => undefined,
	setStatus: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForArchiving: () => undefined,
	setIDForRestoring: () => undefined,
	setFullInfoData: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...customersInitialState,
});
